// extracted by mini-css-extract-plugin
module.exports = {"show-comments":"commenting-widget-module__show-comments__3H3o9","show-comments-btn":"commenting-widget-module__show-comments-btn__1_4MX"};